<template>
  <div
    class="flex items-center gap-[12px] p-[20px] border-[1.5px] rounded-[8px] mb-[8px] cursor-pointer transition-colors"
    :class="{
      '!border-[#F95031]  hover:!border-[#F95031]' : selected && !disabled,
      '!border-[#E2E2E2]  hover:!border-[#F95031]' : !selected && !disabled,
      '!cursor-not-allowed bg-[#F8F8F8] hover:!border-[#E2E2E2]' : disabled,
      'contrast-[0.9]' : disabled && selection,
    }"
    @click="handleClick"
  >
    <b-img
      :src="warehouseLogo"
      alt="warehouse"
      width="48"
      height="48"
      class="rounded-full object-cover size-[48px] brightness-130 contrast-90 saturate-70"
      @error="handleImageError"
    />
    <div>
      <h5
        class="font-[500] text-[16px] mb-[4px]"
        :class="{'text-[#626262]' : disabled, 'text-[#333333]' : !disabled}"
      >
        {{ data.warehouse_name }}
      </h5>
      <p class="text-[#828282] mb-0">
        {{ data.total_products }} produk
      </p>
    </div>
  </div>
</template>

<script>
const FALLBACK_IMAGE = 'https://storage.googleapis.com/komerce/assets/logo/logo-only/Logo-kompack.svg'

export default {
  name: 'CardWarehouse',
  props: {
    data: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    noHover: {
      type: Boolean,
      required: false,
      default: false,
    },
    selection: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      imageError: false,
    }
  },
  computed: {
    warehouseLogo() {
      if (this.imageError) {
        return FALLBACK_IMAGE
      }
      return this.data?.warehouse_logo || FALLBACK_IMAGE
    },
  },
  methods: {
    handleImageError() {
      this.imageError = true
    },
    handleClick() {
      if (this.disabled) return
      this.$emit('click', this.data)
    },
  },
}
</script>
